module.exports = __webpack_public_path__ + "img/ec_private.5f93d3fb.svg";